import types from './constants'

export default {
  [types.PROGRESS_SELECT]: (selection) => ({
   type: types.PROGRESS_SELECT,
   selection
  }),
  [types.PROGRESS_PENDING]: () => ({
   type: types.PROGRESS_PENDING,
  }),
  [types.PROGRESS_COMPLETE]: (report, activities) => ({
   type: types.PROGRESS_COMPLETE,
   report,
   activities,
  }),
  [types.PROGRESS_UPDATED]: (report, activities) => ({
   type: types.PROGRESS_UPDATED,
   report,
   activities,
  }),
  [types.PROGRESS_ERROR]: (error) => ({
   type: types.PROGRESS_ERROR,
   error
  }),
}